import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  BadgeDollarSign,
  Bot,
  Clock3,
  Megaphone,
  Rocket,
  TrendingUp,
  Users,
} from 'lucide-react'

/** Keys, not text: the cards are data, and the labels have to follow the account language. */
const reports = [
  { key: 'LeadEntry', path: '/relatorios/entrada-leads', icon: Users },
  { key: 'Sales', path: '/relatorios/vendas', icon: BadgeDollarSign },
  { key: 'Seller', path: '/relatorios/vendas-vendedor', icon: TrendingUp },
  { key: 'ResponseTime', path: '/relatorios/tempo-resposta', icon: Clock3 },
  { key: 'Campaign', path: '/relatorios/vendas-campanha', icon: Megaphone },
  { key: 'Marketing', path: '/relatorios/performance-marketing', icon: Rocket },
  { key: 'AiAppointments', path: '/relatorios/agendamentos-ia', icon: Bot },
]

export default function Relatorios() {
  const { t } = useTranslation('reports')

  return (
    <div className="flex w-full flex-col gap-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground sm:text-3xl">{t('index.title')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('index.subtitle')}</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {reports.map((report) => {
          const Icon = report.icon
          return (
            <Link
              key={report.path}
              to={report.path}
              className="group rounded-xl border border-border bg-card p-5 transition-colors hover:bg-hover"
            >
              <Icon className="h-6 w-6 text-primary" />
              <h2 className="mt-4 font-semibold text-foreground">{t(`index.card${report.key}`)}</h2>
              <p className="mt-1 text-sm text-muted-foreground">{t(`index.card${report.key}Desc`)}</p>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
